import { Component, Input, Output, EventEmitter } from '@angular/core';
import { BannerImage, BannerData } from '@app/model/banner.model';

@Component({
    selector: 'md-dynamic-banner',
    templateUrl: './dynamic-banner.component.html',
    styleUrls: ['./dynamic-banner.component.scss'],
})
export class DynamicBannerComponent {
    @Input() images: BannerImage[] = [];
    @Input() isMobile = false;
    @Input() placementKey: string = '';

    @Output() bannerClick = new EventEmitter<number>();
    @Output() bannerImpression = new EventEmitter<number>();

    onClick(idx: number): void {
        this.bannerClick.emit(idx);
    }
    onSlide(event: any): void {
        if (!event?.current) return;
        const match = event.current.match(/(\d+)$/);
        const index = match ? +match[1] : 0;
        this.bannerImpression.emit(index);
    }
}
